{
  "name": "patientus",
  "version": "4.4.407",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=local --proxy-config=proxy-local.conf.json --port=4300",
    "start:mac": "ng serve --configuration=local --proxy-config=proxy-local-mac.conf.json",
    "start:linux": "ng serve --configuration=local --proxy-config=proxy-local-linux.conf.json",
    "start-4sigma": "ng serve --host 4sigma.localhost --configuration=local --proxy-config=proxy-local.conf.json",
    "start-4sigma:linux": "ng serve --host 4sigma.localhost --configuration=local --proxy-config=proxy-local-linux.conf.json",
    "start:ssl": "ng serve --ssl true --ssl-key ssl/server.key --ssl-cert ssl/server.crt --proxy-config=proxy-local.conf.json",
    "start:staging": "ng serve --configuration=staging --proxy-config=proxy-local.conf.json",
    "build": "ng build --configuration production",
    "postbuild": "npm run sentry:sourcemaps",
    "build:staging": "ng build --configuration staging",
    "postbuild:staging": "npm run sentry:sourcemaps",
    "build:preview": "ng build --configuration preview",
    "postbuild:preview": "npm run sentry:sourcemaps",
    "test": "ng test --source-map=false --watch=false || true",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "compare-translation": "node compare-translation.js",
    "backend": "node json-server.js",
    "backend-401": "node json-serve-401.js",
    "postinstall": "node version-date.js && node moment-angular-cli-patch.js",
    "postversion": "echo 'all fine'",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org docplanner-frontend --project video-consultation ./dist && sentry-cli sourcemaps upload --org docplanner-frontend --project video-consultation ./dist",
    "deploy:testing": "./scripts/sync-testing-branch.sh origin"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/elements": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/localize": "^21.0.0",
    "@angular/material": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@apollo/client": "^4.0.0",
    "@babel/compat-data": "^7.9.6",
    "@ludovicm67/lib-filetransfer": "^2.0.0",
    "@ludovicm67/simple-whiteboard": "^0.6.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ngrx/component-store": "^21.0.0",
    "@ngrx/effects": "^21.0.0",
    "@ngrx/entity": "^21.0.0",
    "@ngrx/operators": "^21.0.0",
    "@ngrx/router-store": "^21.0.0",
    "@ngrx/store": "^21.0.0",
    "@ngrx/store-devtools": "^21.0.0",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^8.0.0",
    "@noa/recorder": "^0.0.0-beta.27",
    "@opentok/client": "^2.31.1",
    "@patientus/video-lib-angular": "^9.6.0",
    "@popperjs/core": "^2.11.2",
    "@pqina/angular-pintura": "file:pintura/pqina-angular-pintura-8.57.9.tgz",
    "@pqina/pintura": "file:pintura/pqina-pintura-8.94.1.tgz",
    "@sentry/angular": "^10.48.0",
    "@sentry/cli": "^2.53.0",
    "@sentry/types": "^10.12.0",
    "@survicate/survicate-web-package": "^28.2.1-npm",
    "@types/webrtc": "0.0.22",
    "@vonage/ml-transformers": "^5.1.3",
    "angular-file-saver": "^1.1.3",
    "angular2-draggable": "^16.0.0",
    "angular2-multiselect-dropdown": "^9.0.0",
    "apollo-angular": "^13.0.0",
    "blob": "0.1.0",
    "bootstrap": "5.3.2",
    "current-device": "^0.10.2",
    "detect-browser": "^5.1.0",
    "font-awesome": "^4.7.0",
    "graphql": "^16.10.0",
    "graphql-tag": "^2.12.6",
    "jquery": "^3.2.1",
    "mime-types": "^2.1.28",
    "moment": "^2.30.1",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-chips": "^3.0.0",
    "ngx-clipboard": "^16.0.0",
    "ngx-cookie": "^6.0.1",
    "ngx-permissions": "^19.0.0",
    "opentok-layout-js": "^5.5.0",
    "opentok-network-test-js": "4.0.1",
    "path": "^0.12.7",
    "process-nextick-args": "^2.0.1",
    "rxjs": "~7.8.1",
    "tslib": "^2.7.0",
    "ua-parser-js": "^0.7.21",
    "zone.js": "~0.15.0",
    "tsyringe": "^4.10.0",
    "zustand": "^5.0.3",
    "@ngrx/signals": "^21.0.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.0",
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@angular/language-service": "^21.0.0",
    "@ngrx/schematics": "^21.0.0",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^22.5.5",
    "@types/sinon": "^4.1.2",
    "@typescript-eslint/eslint-plugin": "^8.46.1",
    "@typescript-eslint/parser": "^8.46.1",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.0",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "faker": "^5.5.3",
    "fs-extra": "^10.0.0",
    "globby": "^11.1.0",
    "jasmine-core": "~5.3.0",
    "jasmine-marbles": "^0.9.2",
    "jasmine-snapshot": "^1.8.1",
    "jasmine-spec-reporter": "~7.0.0",
    "json-server": "^0.12.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "karma-mocha-reporter": "^2.2.5",
    "lodash": "^4.17.20",
    "material-design-icons": "^3.0.1",
    "mock-socket": "^9.1.2",
    "moment-timezone": "^0.5.17",
    "node-fetch": "^2.6.7",
    "postcss": "^8.3.0",
    "protractor": "~7.0.0",
    "replace-in-file": "^4.1.0",
    "sinon": "^13.0.1",
    "store": "^2.0.12",
    "ts-node": "~10.5.0",
    "typescript": "~5.9.3",
    "reflect-metadata": "^0.2.2"
  }
}
